/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Spin,
  Card,
  message,
} from 'antd';
import Table from 'components/Table';
import toCurrency from 'utils/toCurrency';
import { getRegistrosDeRecaudacion } from 'api/recaudacion/cortes';
import { getMetodosDePago } from 'api/configuracion';
import { hasActionPermission, ActionsNames } from 'utils/permission/index';

const ResumenRegistroDeRecaudacion = ({
  selectedRowKey,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [metodoDePago, setMetodoDePago] = useState([]);
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRegistrosDeRecaudacion(selectedRowKey);
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const validatePermission = () => {
      const _hasAllViewPermission = hasActionPermission('catalogodemetododepago',
        ActionsNames.view);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) setHasAllViewPermission(_hasAllViewPermission);
    };
    const fetchAll = async () => {
      setLoading(true);
      const dataMetodos = await getMetodosDePago();
      if (mounted) {
        setMetodoDePago(dataMetodos);
      }
      await fetchData();
    };
    validatePermission();
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Método de pago',
      dataIndex: 'metodo_de_pago',
      key: 'metodo_de_pago',
      width: 200,
      inputWidth: 150,
      render: (val) => (metodoDePago.find((item) => item.id === val)?.concepto),
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      inputWidth: 150,
      render: (val) => toCurrency(val),

    },
  ];

  return (
    <Row align="center" justify="center" className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Card
          bordered={false}
          className="form-container"
        >
          <Col>
            <Table
              cols={columns}
              data={data}
              loading={loading}
              noControls
              mobileColIndex={0}
              hasAllViewPermission={hasAllViewPermission}
            />
          </Col>
        </Card>
      </Spin>
    </Row>
  );
};

export default ResumenRegistroDeRecaudacion;
